import React, { useState, useEffect, useContext } from 'react';
import styled from 'styled-components';
import { Modal } from 'react-responsive-modal';
import { AuthContext } from '../../navigation/AuthProvider';
import CustomTable from '../Table';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
};

const details = [
  {
    id: 0,
    type: '충전금액',
    count: 0,
  },
  {
    id: 1,
    type: '충전캐시',
    count: 0,
  },
];

const ChargeTalkModal = ({ isVisible, setVisible }: Props) => {
  const oAuthContext = useContext(AuthContext);

  const onClose = () => {
    setVisible(false);
  };

  return (
    <Modal
      open={isVisible}
      onClose={onClose}
      center
      blockScroll={false}
      classNames={{
        overlay: 'talkModalOverlay',
        modal: 'talkModal',
        root: 'customModalRoot',
      }}
      showCloseIcon={true}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <h2>충전내역 상세보기</h2>
          <h4>2024-01-08</h4>
          <div className="row">
            <div className="tableItem topLeft">
              <h3>충전금액</h3>
            </div>
            <div className="tableItem topRight">
              <h3>000원</h3>
            </div>
          </div>
          <div className="row">
            <div className="tableItem bottomLeft">
              <h3>충전캐시</h3>
            </div>
            <div className="tableItem bottomRight">
              <h3>000캐시</h3>
              <p>(00캐시 증정)</p>
            </div>
          </div>
          {/* <div className="footer">
            <p>• 7일 이내 캐시 미사용시에만 결제 취소 가능합니다.</p>
            <button className="cancelButton" onClick={openCancel}>
              <h4>결제 취소 신청</h4>
            </button>
          </div> */}
        </div>
      </Style>
    </Modal>
  );
};

export default ChargeTalkModal;

const Style = styled.div`
  h1,
  h2,
  h3,
  h4,
  p {
    padding: 0;
    margin: 0;
  }
  /* modalWrapper */
  .modalWrapper {
    height: 100%;
    padding: 8%;
    background: #fff;
    overflow: hidden;
  }

  h2 {
    text-align: left;
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
  h4 {
    text-align: right;
    color: #a7a7a7;
    font-weight: 400;
    padding: 6px 0;
  }

  .row {
    display: flex;
    align-items: center;
  }
  .tableItem {
    flex: 1;
    min-height: 60px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    h3 {
      font-weight: 500;
    }
  }
  .tableItem.topLeft {
    border: 1px solid #e3e3e3;
    background: #f7f7f7;
    border-radius: 5px 0 0 0;
  }
  .tableItem.topRight {
    border: 1px solid #e3e3e3;
    border-left: none;
    border-radius: 0 5px 0 0;
    h3 {
      font-weight: 400;
    }
  }
  .tableItem.bottomLeft {
    border: 1px solid #e3e3e3;
    background: #f7f7f7;
    border-top: none;
    border-radius: 0 0 0 5px;
  }
  .tableItem.bottomRight {
    border: 1px solid #e3e3e3;
    border-left: none;
    border-top: none;
    border-radius: 0 0 5px 0;
    h3 {
      font-weight: 400;
    }
    p {
      font-size: 10px;
      line-height: 14px;
      color: #237ce4;
    }
  }

  .footer {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-size: 12px;
      line-height: 16px;
      font-weight: 500;
      color: #a7a7a7;
    }
    .cancelButton {
      border-radius: 5px;
      padding: 6px 20px;
      border: 1px solid #ff5757;
      cursor: pointer;
      h4 {
        color: #ff5757;
        font-weight: 500;
        white-space: nowrap;
      }
    }
  }

  @media (max-width: 900px) {
    .modalWrapper {
      padding: 32px 4%;
    }
    .footer {
      flex-direction: column;
      align-items: flex-start;

      .cancelButton {
        margin-top: 4px;
        margin-left: auto;
      }
    }
  }
`;
